import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import NotificationsSettingsPage, { getDefaultPageUI } from "components/pages/NotificationsSettingsPage";
import { getDefaultAddEmail } from "components/workflows/AddEmailContactMethodModalWorkflow";
import Classes, { ContactInfo } from "model";

export default function CaptureNotifiLimEmailActive(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    const newInfo = ContactInfo.init({
        id: 100,
        isPrimary: "false",
        isConfirmed: "true",
        value: "sample@samplemail.com",
        userEnteredActivationCode: "123456"
    });

    const modalData = BCMSStateManagerCRUD.init(getDefaultAddEmail("addEmailWorkflow", undefined))
        .update([ "data", "info", "value" ], "sample@samplemail.com")
        .update([ "data", "unconfirmedContacts" ], [ newInfo ])
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "AddContactMethodModal")
        .update([ "modal", "data" ], { workflowType: "addEmailWorkflow", values: modalData, step: 1 })
        .submit();

    return <NotificationsSettingsPage ui={ ui } />
}